/**
 * Real load times from this device, so slowness away from home can be measured instead of guessed.
 * Sends only a kind of item and how long it took, never an address, title or photo.
 */
const KINDS = [
  [/^\/api\/(movies|shows)\/resume/, 'continue'],
  [/^\/art\/(audiobooks|podcasts|ol|isbn)\//, 'cover'],
  [/^\/art\/|^\/jellyfin\/Items\//, 'poster'],
  [/^\/api\/immich\/.*\/thumbnail/, 'photo'],
  [/^\/api\/immich\/.*\/preview/, 'photoFull'],
  [/^\/api\/(audiobooks|podcasts|openlibrary)\/.*(cover|image)/, 'cover'],
  [/^\/static\//, 'app'],
];
const SEND_MS = 60 * 1000;
const MAX_PER_KIND = 60;

export function startPerfReports() {
  if (typeof window === 'undefined' || typeof PerformanceObserver !== 'function') return;
  let times = {};
  let count = 0;
  const note = (kind, ms, saved) => {
    const list = times[kind] || (times[kind] = []);
    if (list.length >= MAX_PER_KIND) return;
    list.push(saved ? [Math.round(ms), 1] : [Math.round(ms)]);
    count += 1;
  };
  try {
    new PerformanceObserver((found) => {
      for (const e of found.getEntries()) {
        let path;
        try {
          path = new URL(e.name).pathname;
        } catch (_) {
          continue;
        }
        const hit = KINDS.find(([rx]) => rx.test(path));
        /** transferSize 0 with a response means the device's saved copy answered. */
        if (hit) note(hit[1], e.duration, e.transferSize === 0 && e.decodedBodySize > 0);
      }
    }).observe({ type: 'resource', buffered: true });
  } catch (_) {
    return;
  }
  setInterval(() => {
    if (!count || document.hidden) return;
    const body = JSON.stringify({ net: navigator.connection?.effectiveType || '', times });
    times = {};
    count = 0;
    fetch('/api/perf', { method: 'POST', credentials: 'include', keepalive: true, headers: { 'Content-Type': 'application/json' }, body }).catch(() => {});
  }, SEND_MS);
}
